<template>
  <div>
    <v-card>
      <v-toolbar dense card>
        <v-toolbar-title class="body-2 beez-bold">
          Add Items to the Package
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu bottom left>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-tile @click="fetchAutomationServices">
              <v-list-tile-title
                >Update Automation Service List</v-list-tile-title
              >
            </v-list-tile>
            <v-list-tile @click="fetchWorkflows">
              <v-list-tile-title>Update Workflow List</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="fetchBots">
              <v-list-tile-title>Update Bot List</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="fetchBotTemplates">
              <v-list-tile-title>Update Bot Template List</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="fetchRules">
              <v-list-tile-title>Update Rule List</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="fetchHoneyRoles">
              <v-list-tile-title>Update Honey Role List</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="fetchHoneyForms">
              <v-list-tile-title>Update Form List</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="fetchEmailTemplates">
              <v-list-tile-title>Update Email Template List</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap justify-space-around align-center>
          <v-flex xs12 md6 class="pa-2">
            <editable-list-view
              key="automation-service-selection"
              :allItems="automationServices"
              :search-attributes="searchAttributes"
              :selected-items="selectedAutomationServices"
              :updating="automationServicesUpdating || automationServiceLoading"
              title="Add Automation Services to Package"
              @added="automationServicesAdded"
              @deleted="automationServicesDeleted"
              @queryChanged="query => search(query, 'selfService')"
            >
              <template slot="empty-list-placeholder-selected">
                Please click the edit icon to start adding Automation Services.
              </template>
              <template
                v-for="(slotName, i) in [
                  'list-item-selected',
                  'list-item-add',
                  'list-item-delete'
                ]"
                :slot="slotName"
                slot-scope="slotProps"
              >
                <v-hover :key="'item3_' + i">
                  <v-list-tile-content>
                    <v-container fulid>
                      <v-layout row>
                        <v-flex shrink>
                          <v-avatar size="40">
                            <img alt="link" src="/images/Bot.svg" />
                          </v-avatar>
                        </v-flex>
                        <v-flex grow pl-3>
                          <v-list-tile-title
                            >{{ slotProps.item.name }}
                          </v-list-tile-title>
                          <v-list-tile-sub-title
                            >{{ slotProps.item.description }}
                          </v-list-tile-sub-title>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-list-tile-content>
                </v-hover>
              </template>
            </editable-list-view>
          </v-flex>
          <v-flex xs12 md6 class="pa-2">
            <editable-list-view
              key="workflow-selection"
              :allItems="workflows"
              :search-attributes="searchAttributes"
              :selected-items="selectedWorkflows"
              :updating="workflowsUpdating || workflowsLoading"
              title="Add Workflows to Package"
              @added="workflowsAdded"
              @deleted="workflowsDeleted"
              @queryChanged="query => search(query, 'workflow')"
            >
              <template slot="empty-list-placeholder-selected">
                Please click the edit icon to start adding Workflows.
              </template>
              <template
                v-for="(slotName, i) in [
                  'list-item-selected',
                  'list-item-add',
                  'list-item-delete'
                ]"
                :slot="slotName"
                slot-scope="slotProps"
              >
                <v-hover :key="'item3_' + i">
                  <v-list-tile-content>
                    <v-container fulid>
                      <v-layout row>
                        <v-flex shrink>
                          <v-avatar size="40">
                            <img alt="link" src="/images/Workflow.svg" />
                          </v-avatar>
                        </v-flex>
                        <v-flex grow pl-3>
                          <v-list-tile-title
                            >{{ slotProps.item.name }}
                          </v-list-tile-title>
                          <v-list-tile-sub-title
                            >{{ slotProps.item.description }}
                          </v-list-tile-sub-title>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-list-tile-content>
                </v-hover>
              </template>
            </editable-list-view>
          </v-flex>
          <v-flex xs12 md6 class="pa-2">
            <editable-list-view
              key="bot-selection"
              :allItems="bots"
              :search-attributes="searchAttributes"
              :selected-items="selectedBots"
              :updating="botsUpdating || botsLoading"
              title="Add Bots to Package"
              @added="botsAdded"
              @deleted="botsDeleted"
              @queryChanged="query => search(query, 'bots')"
            >
              <template slot="empty-list-placeholder-selected">
                Please click the edit icon to start adding Bots.
              </template>
              <template
                v-for="(slotName, i) in [
                  'list-item-selected',
                  'list-item-add',
                  'list-item-delete'
                ]"
                :slot="slotName"
                slot-scope="slotProps"
              >
                <v-hover :key="'item3_' + i">
                  <v-list-tile-content>
                    <v-container fulid>
                      <v-layout row>
                        <v-flex shrink>
                          <v-avatar size="40">
                            <img alt="link" src="/images/Bot.svg" />
                          </v-avatar>
                        </v-flex>
                        <v-flex grow pl-3>
                          <v-list-tile-title
                            >{{ slotProps.item.name }}
                          </v-list-tile-title>
                          <v-list-tile-sub-title
                            >{{ slotProps.item.description }}
                          </v-list-tile-sub-title>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-list-tile-content>
                </v-hover>
              </template>
            </editable-list-view>
          </v-flex>
          <v-flex xs12 md6 class="pa-2">
            <editable-list-view
              key="bot-template-selection"
              :allItems="botTemplates"
              :search-attributes="searchAttributes"
              :selected-items="selectedBotTemplates"
              :updating="botTemplatesUpdating || botTemplatesLoading"
              title="Add Bot Templates to Package"
              @added="botTemplatesAdded"
              @deleted="botTemplatesDeleted"
              @queryChanged="query => search(query, 'botTemplate')"
            >
              <template slot="empty-list-placeholder-selected">
                Please click the edit icon to start adding Bot Templates.
              </template>
              <template
                v-for="(slotName, i) in [
                  'list-item-selected',
                  'list-item-add',
                  'list-item-delete'
                ]"
                :slot="slotName"
                slot-scope="slotProps"
              >
                <v-hover :key="'item3_' + i">
                  <v-list-tile-content>
                    <v-container fulid>
                      <v-layout row>
                        <v-flex shrink>
                          <v-avatar size="40">
                            <img alt="link" src="/images/Bot.svg" />
                          </v-avatar>
                        </v-flex>
                        <v-flex grow pl-3>
                          <v-list-tile-title
                            >{{ slotProps.item.name }}
                          </v-list-tile-title>
                          <v-list-tile-sub-title
                            >{{ slotProps.item.description }}
                          </v-list-tile-sub-title>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-list-tile-content>
                </v-hover>
              </template>
            </editable-list-view>
          </v-flex>
          <v-flex xs12 md6 class="pa-2">
            <editable-list-view
              key="rule-selection"
              :allItems="rules"
              :search-attributes="searchAttributes"
              :selected-items="selectedRules"
              :updating="rulesUpdating || rulesLoading"
              title="Add Rules to Package"
              @added="rulesAdded"
              @deleted="rulesDeleted"
              @queryChanged="query => search(query, 'rules')"
            >
              <template slot="empty-list-placeholder-selected">
                Please click the edit icon to start adding Rules.
              </template>
              <template
                v-for="(slotName, i) in [
                  'list-item-selected',
                  'list-item-add',
                  'list-item-delete'
                ]"
                :slot="slotName"
                slot-scope="slotProps"
              >
                <v-hover :key="'item3_' + i">
                  <v-list-tile-content>
                    <v-container fulid>
                      <v-layout row>
                        <v-flex shrink>
                          <v-avatar size="40">
                            <img alt="link" src="/images/Bot.svg" />
                          </v-avatar>
                        </v-flex>
                        <v-flex grow pl-3>
                          <v-list-tile-title
                            >{{ slotProps.item.name }}
                          </v-list-tile-title>
                          <v-list-tile-sub-title
                            >{{ slotProps.item.description }}
                          </v-list-tile-sub-title>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-list-tile-content>
                </v-hover>
              </template>
            </editable-list-view>
          </v-flex>
          <v-flex xs12 md6 class="pa-2">
            <editable-list-view
              key="honey-roles-selection"
              :allItems="honeyRoles"
              :search-attributes="searchAttributes"
              :selected-items="selectedHoneyRoles"
              :updating="honeyRolesUpdating || honeyRolesLoading"
              title="Add Honey Roles to Package"
              @added="honeyRolesAdded"
              @deleted="honeyRolesDeleted"
              @queryChanged="query => search(query, 'roles')"
            >
              <template slot="empty-list-placeholder-selected">
                Please click the edit icon to start adding Honey Roles.
              </template>
              <template
                v-for="(slotName, i) in [
                  'list-item-selected',
                  'list-item-add',
                  'list-item-delete'
                ]"
                :slot="slotName"
                slot-scope="slotProps"
              >
                <v-hover :key="'item3_' + i">
                  <v-list-tile-content>
                    <v-container fulid>
                      <v-layout row>
                        <v-flex shrink>
                          <v-avatar size="40">
                            <img alt="link" src="/images/Bot.svg" />
                          </v-avatar>
                        </v-flex>
                        <v-flex grow pl-3>
                          <v-list-tile-title
                            >{{ slotProps.item.name }}
                          </v-list-tile-title>
                          <v-list-tile-sub-title
                            >{{ slotProps.item.description }}
                          </v-list-tile-sub-title>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-list-tile-content>
                </v-hover>
              </template>
            </editable-list-view>
          </v-flex>
          <v-flex xs12 md6 class="pa-2">
            <editable-list-view
              key="honey-forms-selection"
              :allItems="honeyForms"
              :search-attributes="searchAttributes"
              :selected-items="selectedHoneyForms"
              :updating="honeyFormsUpdating || honeyFormsLoading"
              title="Add Forms to Package"
              @added="honeyFormsAdded"
              @deleted="honeyFormsDeleted"
              @queryChanged="query => search(query, 'honeyForms')"
            >
              <template slot="empty-list-placeholder-selected">
                Please click the edit icon to start adding Forms.
              </template>
              <template
                v-for="(slotName, i) in [
                  'list-item-selected',
                  'list-item-add',
                  'list-item-delete'
                ]"
                :slot="slotName"
                slot-scope="slotProps"
              >
                <v-hover :key="'item3_' + i">
                  <v-list-tile-content>
                    <v-container fulid>
                      <v-layout row>
                        <v-flex shrink>
                          <v-avatar size="40">
                            <img alt="link" src="/images/Bot.svg" />
                          </v-avatar>
                        </v-flex>
                        <v-flex grow pl-3>
                          <v-list-tile-title
                            >{{ slotProps.item.formKey }}
                          </v-list-tile-title>
                          <v-list-tile-sub-title
                            >{{ slotProps.item.description }}
                          </v-list-tile-sub-title>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-list-tile-content>
                </v-hover>
              </template>
            </editable-list-view>
          </v-flex>
          <v-flex xs12 md6 class="pa-2">
            <editable-list-view
              key="email-templates-selection"
              :allItems="emailTemplates"
              :search-attributes="searchAttributes"
              :selected-items="selectedEmailTemplates"
              :updating="emailTemplatesLoading || emailTemplatesUpdating"
              title="Add Email Templates to Package"
              @added="emailTemplatesAdded"
              @deleted="emailTemplatesDeleted"
              @queryChanged="query => search(query, 'emailTemplate')"
            >
              <template slot="empty-list-placeholder-selected">
                Please click the edit icon to start adding Email Templates.
              </template>
              <template
                v-for="(slotName, i) in [
                  'list-item-selected',
                  'list-item-add',
                  'list-item-delete'
                ]"
                :slot="slotName"
                slot-scope="slotProps"
              >
                <v-hover :key="'item3_' + i">
                  <v-list-tile-content>
                    <v-container fulid>
                      <v-layout row>
                        <v-flex shrink>
                          <v-avatar size="40">
                            <img alt="link" src="/images/Bot.svg" />
                          </v-avatar>
                        </v-flex>
                        <v-flex grow pl-3>
                          <v-list-tile-title
                            >{{ slotProps.item.name }}
                          </v-list-tile-title>
                          <v-list-tile-sub-title
                            >{{ slotProps.item.description }}
                          </v-list-tile-sub-title>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-list-tile-content>
                </v-hover>
              </template>
            </editable-list-view>
          </v-flex>
          <v-flex xs12 md6 class="pa-2">
            <v-form ref="variableForm" v-model="validForm">
              <v-textarea
                v-model="description"
                outline
                label="Package Description"
                :counter="250"
                :rules="[v => !!v || 'Description is required']"
              ></v-textarea>
            </v-form>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-layout justify-center>
          <v-btn
            :class="
              !$vuetify.dark ? 'secondary text-capitalize' : 'text-capitalize'
            "
            :color="$vuetify.dark ? 'secondary' : ''"
            :outline="$vuetify.dark"
            @click="createPackage"
            :disabled="!validForm"
            :loading="createLoader"
            ><v-icon>archive</v-icon> Create Package
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import EditableListView from '@/components/common/EditableListView'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import {
  botApi,
  botTemplateApi,
  formApi,
  honeyRolesApi,
  ruleApi,
  selfServiceApi,
  workflowApi,
  emailTemplatesApi
} from '../../api'
export default {
  name: 'CreatePackage',
  components: {
    EditableListView
  },
  data() {
    return {
      description: '',
      validForm: false,
      createLoader: false,
      addedItems: [],
      searchAttributes: ['name', 'description', 'hexId'],
      selectedWorkflows: [],
      workflowsUpdating: false,
      workflowsLoading: false,
      selectedAutomationServices: [],
      automationServicesUpdating: false,
      automationServiceLoading: false,
      selectedRules: [],
      rulesUpdating: false,
      rulesLoading: false,
      selectedHoneyForms: [],
      honeyFormsUpdating: false,
      honeyFormsLoading: false,
      selectedHoneyRoles: [],
      honeyRolesUpdating: false,
      honeyRolesLoading: false,
      selectedEmailTemplates: [],
      emailTemplatesUpdating: false,
      emailTemplatesLoading: false,
      selectedBots: [],
      botsUpdating: false,
      botsLoading: false,
      selectedBotTemplates: [],
      botTemplatesUpdating: false,
      botTemplatesLoading: false,
      automationServices: [],
      workflows: [],
      bots: [],
      botTemplates: [],
      rules: [],
      honeyRoles: [],
      honeyForms: [],
      emailTemplates: []
    }
  },
  created() {
    // if (this.workflows && this.workflows.length === 0) {
    //   this.fetchWorkflows()
    // }
    // if (this.bots && this.bots.length === 0) {
    //   this.fetchBots()
    // }
    // if (this.botTemplates && this.botTemplates.length === 0) {
    //   this.fetchBotTemplates()
    // }
    // if (this.botTemplates && this.botTemplates.length === 0) {
    //   this.fetchBotTemplates()
    // }
    // if (this.automationServices && this.automationServices.length === 0) {
    //   this.fetchAutomationServices()
    // }
    // if (this.rules && this.rules.length === 0) {
    //   this.fetchRules()
    // }
    // if (this.honeyForms && this.honeyForms.length === 0) {
    //   this.fetchHoneyForms()
    // }
    // if (this.honeyRoles && this.honeyRoles.length === 0) {
    //   this.fetchHoneyRoles()
    // }
    // if (this.emailTemplates && this.emailTemplates.length === 0) {
    //   this.fetchEmailTemplates()
    // }
  },
  computed: {
    ...mapState({
      // bots: state => state.bots.bots,
      workflows: state => state.workflows.workflows,
      selfServices: state => state.selfServices.selfServices,
      // botTemplates: state => state.botTemplates.botTemplates,
      honeyUsers: state => state.honeyUsers.honeyUsers
      // automationServices: state => state.selfServices.selfServices,
      // honeyForms: state => state.honeyForms.honeyForms,
      // honeyRoles: state => state.honeyRoles.honeyRoles,
      // emailTemplates: state => state.emailTemplates.emailTemplates
      // rules: state => state.rules.rules
    }),
    ...mapGetters({
      can: 'can'
    })
  },
  methods: {
    async createPackage() {
      this.createLoader = true
      try {
        let body = {}
        body.description = this.description
        body.workflows = this.selectedWorkflows.map(i => i.hexId)
        body.bots = this.selectedBots.map(i => i.hexId)
        body.botTemplates = this.selectedBotTemplates.map(i => i.hexId)
        body.automationServices = this.selectedAutomationServices.map(
          i => i.hexId
        )
        body.rules = this.selectedRules.map(i => i.hexId)
        body.honeyRoles = this.selectedHoneyRoles.map(i => i.hexId)
        body.honeyForms = this.selectedHoneyForms.map(i => i.hexId)
        body.emailTemplates = this.selectedEmailTemplates.map(i => i.hexId)

        let aPackage = await this.$store.dispatch('createPackage', body)
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Package created successfully',
          description: `Package ${aPackage.hexId} has been created successfully`,
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Error in creating package',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.createLoader = false
      this.$emit('packageAdded')
    },
    async fetchAutomationServices(e, url) {
      this.automationServiceLoading = true
      try {
        // await this.$store.dispatch('fetchSelfServices')
        const { data } = await selfServiceApi.fetchSelfServices(url)
        this.automationServices = data._embedded.selfServices
      } catch (e) {
        console.log(e)
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Self services',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.automationServiceLoading = false
    },
    automationServicesAdded(automationServices) {
      this.automationServicesUpdating = true
      this.selectedAutomationServices = this.selectedAutomationServices.concat(
        automationServices
      )
      this.automationServicesUpdating = false
    },
    automationServicesDeleted(automationServices) {
      this.automationServicesUpdating = true
      automationServices.forEach(automationService => {
        this.selectedAutomationServices = this.selectedAutomationServices.filter(
          item => item.hexId !== automationService.hexId
        )
      })
      this.automationServicesUpdating = false
    },
    async fetchRules(_, url) {
      this.rulesLoading = true
      try {
        // await this.$store.dispatch('fetchRules')
        const { data } = await ruleApi.fetchRules(url)
        this.rules = data._embedded.rules
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Rules',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.rulesLoading = false
    },
    rulesAdded(rules) {
      this.rulesUpdating = true
      this.selectedRules = this.selectedRules.concat(rules)
      this.rulesUpdating = false
    },
    rulesDeleted(rules) {
      this.rulesUpdating = true
      rules.forEach(rule => {
        this.selectedRules = this.selectedRules.filter(
          item => item.hexId !== rule.hexId
        )
      })
      this.rulesUpdating = false
    },
    async fetchHoneyForms(_, url) {
      this.honeyFormsLoading = true
      try {
        // await this.$store.dispatch('fetchHoneyForms')
        const { data } = await formApi.fetchForms(url)
        this.honeyForms = data._embedded.honeyForms
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Forms',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.honeyFormsLoading = false
    },
    honeyFormsAdded(honeyForms) {
      this.honeyFormsUpdating = true
      this.selectedHoneyForms = this.selectedHoneyForms.concat(honeyForms)
      this.honeyFormsUpdating = false
    },
    honeyFormsDeleted(honeyForms) {
      this.honeyFormsUpdating = true
      honeyForms.forEach(honeyForm => {
        this.selectedHoneyForms = this.selectedHoneyForms.filter(
          item => item.hexId !== honeyForm.hexId
        )
      })
      this.honeyFormsUpdating = false
    },
    async fetchHoneyRoles(_, url) {
      this.honeyRolesLoading = true
      try {
        // await this.$store.dispatch('fetchHoneyRoles')
        const roles = await honeyRolesApi.fetchHoneyRoles(url)
        this.honeyRoles = roles
      } catch (e) {
        console.log(e)
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Honey Roles',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.honeyRolesLoading = false
    },
    honeyRolesAdded(honeyRoles) {
      this.honeyRolesUpdating = true
      this.selectedHoneyRoles = this.selectedHoneyRoles.concat(honeyRoles)
      this.honeyRolesUpdating = false
    },
    honeyRolesDeleted(honeyRoles) {
      this.honeyRolesUpdating = true
      honeyRoles.forEach(honeyRole => {
        this.selectedHoneyRoles = this.selectedHoneyRoles.filter(
          item => item.hexId !== honeyRole.hexId
        )
      })
      this.honeyRolesUpdating = false
    },
    async fetchEmailTemplates(_, url) {
      this.emailTemplatesLoading = true
      try {
        // await this.$store.dispatch('fetchEmailTemplates')
        const { data } = await emailTemplatesApi.fetchEmailTemplates(url)
        this.emailTemplates = data._embedded.emailTemplates
      } catch (e) {
        console.log(e)
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Email Templates',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.emailTemplatesLoading = false
    },
    emailTemplatesAdded(emailTemplates) {
      this.emailTemplatesUpdating = true
      this.selectedEmailTemplates = this.selectedEmailTemplates.concat(
        emailTemplates
      )
      this.emailTemplatesUpdating = false
    },
    emailTemplatesDeleted(emailTemplates) {
      this.emailTemplatesUpdating = true
      emailTemplates.forEach(emailTemplate => {
        this.selectedEmailTemplates = this.selectedEmailTemplates.filter(
          item => item.hexId !== emailTemplate.hexId
        )
      })
      this.emailTemplatesUpdating = false
    },
    async fetchWorkflows(_, url) {
      this.workflowsLoading = true
      try {
        // await this.$store.dispatch('fetchWorkflows')
        const { data } = await workflowApi.fetchWorkflows(url)
        this.workflows = data._embedded.workflows
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Error in getting workflows',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.workflowsLoading = false
    },
    workflowsAdded(workflows) {
      this.workflowsUpdating = true
      this.selectedWorkflows = this.selectedWorkflows.concat(workflows)
      this.workflowsUpdating = false
    },
    workflowsDeleted(workflows) {
      this.workflowsUpdating = true
      workflows.forEach(workflow => {
        this.selectedWorkflows = this.selectedWorkflows.filter(
          item => item.hexId !== workflow.hexId
        )
      })
      this.workflowsUpdating = false
    },
    async fetchBots(_, url) {
      this.botsLoading = true
      try {
        // await this.$store.dispatch('fetchBots')
        const { data } = await botApi.fetchBots(url)
        this.bots = data._embedded.bots
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Error in getting bots',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.botsLoading = false
    },
    botsAdded(bots) {
      this.botsUpdating = true
      this.selectedBots = this.selectedBots.concat(bots)
      this.botsUpdating = false
    },
    botsDeleted(bots) {
      this.botsUpdating = true
      bots.forEach(bot => {
        this.selectedBots = this.selectedBots.filter(
          item => item.hexId !== bot.hexId
        )
      })
      this.botsUpdating = false
    },
    async fetchBotTemplates(_, url) {
      this.botTemplatesLoading = true
      try {
        // await this.$store.dispatch('fetchBotTemplates')
        const { data } = await botTemplateApi.fetchBotTemplates(url)
        this.botTemplates = data._embedded.botTemplates
      } catch (e) {
        console.log(e)
        await this.$store.dispatch('directNotification', {
          message: 'Error in getting bot templates',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.botTemplatesLoading = false
    },
    botTemplatesAdded(botTemplates) {
      this.botTemplatesUpdating = true
      this.selectedBotTemplates = this.selectedBotTemplates.concat(botTemplates)
      this.botTemplatesUpdating = false
    },
    botTemplatesDeleted(botTemplates) {
      this.botTemplatesUpdating = true
      botTemplates.forEach(botTemplate => {
        this.selectedBotTemplates = this.selectedBotTemplates.filter(
          item => item.hexId !== botTemplate.hexId
        )
      })
      this.botTemplatesUpdating = false
    },
    async search(query, category) {
      try {
        const url = `?search=${query}&page=1&size=20`

        switch (category) {
          case 'selfService': {
            this.fetchAutomationServices('', url)
            break
          }
          case 'workflow': {
            this.fetchWorkflows('', url)
            break
          }
          case 'bots': {
            this.fetchBots('', url)
            break
          }
          case 'botTemplate': {
            this.fetchBotTemplates('', url)
            break
          }
          case 'rules': {
            this.fetchRules('', url)
            break
          }
          case 'roles': {
            this.fetchHoneyRoles('', url)
            break
          }
          case 'honeyForms': {
            this.fetchHoneyForms('', url)
            break
          }
          case 'emailTemplate': {
            this.fetchEmailTemplates('', url)
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style scoped></style>
